/* eslint-disable import/no-internal-modules */
import { CartIconButtonMobileV2 } from "user_site/features/cart";
import { WithProviders } from "user_site/utils";

const Component = () => (
  <WithProviders>
    <CartIconButtonMobileV2 />
  </WithProviders>
);

export default Component;
